import React from 'react';
import './BuyVehicleSteps.css'; // Add your CSS styling here
import FindCarSection from './FindCarSection';
// import SubscribeSection from './SubscribeSection';
import Membership from './Membership';
// import Auction from './Auction';
// import TrustedPlatform from './TrustedPlatform';
// import Step4 from './Step4';

const BuyVehicleSteps = () => {
  return (
    <div class="steps-container1" 
    

   
 >
  
     
      <div class="" >
      <div class="banner" style={{
      backgroundImage: "url('/assets/img/slider/furqan.jpg')",
      backgroundSize: "cover", // Ensures the image covers the entire div
      backgroundPosition: "center",
      height:"400px", // Centers the image
      width: "100%", // Full-width container
      
    }} >
        <div class="text-container1">
          <h1>Step-by-step Instructions</h1>
          <h2>On How To Buy Used Vehicle Online</h2>
        </div>
       <div className="steps-container2">
  <div className="step2">
    <img src="/assets/img/magnifying-glass.png" alt="Find Vehicle Icon" />
    <p className="step-number2">1</p>
    <h3 class="classh3">Find Vehicle</h3>
  </div>
  <div className="arrow2">
    <i className="fa-solid fa-arrow-right"></i>
  </div>
  <div className="step2">
    <img src="/assets/img/member-icon.png" alt="Become a Member Icon" />
    <p className="step-number2">2</p>
    <h3 class="classh3">Become a Member</h3>
  </div>
  <div className="arrow2">
    <i className="fa-solid fa-arrow-right"></i>
  </div>
  <div className="step2">
    <img src="/assets/img/win-auction-icon.png" alt="Win Auction Icon" />
    <p className="step-number2">3</p>
    <h3 class="classh3">Win Auction</h3>
  </div>
</div>

        </div>
        <FindCarSection/>
        <Membership/>
        {/* <SubscribeSection/> */}
        {/* <Auction/> */}
        {/* <Step4/> */}
        {/* <TrustedPlatform/> */}
      </div>
    </div>
  );
};

export default BuyVehicleSteps;